<template>
  <div id="contact" class="d-flex flex-column align-items-stretch h-100">
    <div class="row row-container m-0">
      <div class="col-3 row-container contact-list">
        <div class="col-item">
          <div>
            <div class="p-3">
              <div class="row pb-3">
                <div class="col-sm-12">
                  <div class="pb-3">
                    <label for="topicid">เลขที่การติดต่อ</label>
                    <el-input
                      type="text"
                      id="topicid"
                      name="topicid"
                      v-model="topicId"
                    ></el-input>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="pb-3">
                    <label for="textReply">ข้อความ</label>
                    <el-input
                      type="text"
                      id="textReply"
                      name="textReply"
                      v-model="textReply"
                    ></el-input>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="pb-3">
                    <label for="name">ชื่อผู้ติดต่อ</label>
                    <el-input
                      type="text"
                      id="name"
                      name="name"
                      v-model="name"
                    ></el-input>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="pb-3">
                    <label for="categories">ประเภทการติดต่อ</label>
                    <el-select
                      id="categories"
                      name="categories"
                      placeholder=" - ประเภทการติดต่อ - "
                      clearable
                      v-model="conversationCategory"
                    >
                      <el-option
                        v-for="item in conversationCategoryList"
                        :key="item.contactCategoryId"
                        :label="item.title"
                        :value="item.contactCategoryId"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="pb-3">
                    <label for="project_name">ชื่อโครงการ</label>
                    <el-select
                      id="project_name"
                      name="project_name"
                      placeholder=" - ประเภทการติดต่อ - "
                      filterable
                      clearable
                      v-model="project"
                    >
                      <el-option-group
                        v-for="list in projectList"
                        :key="list.label"
                        :label="list.label"
                      >
                        <el-option
                          v-for="item in list.projects"
                          :key="item.projectCode"
                          :label="item.projectName"
                          :value="item.projectId"
                        >
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="pb-3">
                    <label for="home_address">บ้านเลขที่</label>
                    <el-input
                      type="text"
                      id="home_address"
                      name="home_address"
                      v-model="homeAddress"
                    ></el-input>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="pb-3">
                    <label for="created_at">วันที่เริ่มการติดต่อ</label>
                    <el-date-picker
                      id="created_at"
                      name="created_at"
                      v-model="createdAt"
                      format="dd-MM-yyyy"
                      start-placeholder="เริ่ม"
                      end-placeholder="สิ้นสุด"
                      range-separator="ถึง"
                      type="datetimerange"
                    />
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="pb-3">
                    <label for="created_at">วันที่มีการสนทนาคร้งล่าสุด</label>
                    <el-date-picker
                      id="lates_reply_at"
                      name="lates_reply_at"
                      v-model="latestReplyAt"
                      format="dd-MM-yyyy"
                      start-placeholder="เริ่ม"
                      end-placeholder="สิ้นสุด"
                      range-separator="ถึง"
                      type="datetimerange"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 text-right">
                  <el-button
                    class="sc-button sc-btn-outline"
                    size="medium"
                    @click="getconversationList()"
                    >ค้นหา</el-button
                  >
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="pb-3 text-right">
                <!-- <el-button class="sc-button sc-btn-outline">ดาวน์โหลดการติดต่อ</el-button> -->
                <download-excel
                  class="el-button sc-button sc-btn-outline el-button--default"
                  :fields="conversationStatField"
                  :data="conversationStatData"
                  type="xls"
                  name="conversation-stat.xls"
                  >ดาวน์โหลดการติดต่อ</download-excel
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-9 row-container contact-list">
        <ul class="topic-cases nav tabs p-0" style="height: 50px;">
          <li
            role="presentation"
            data-toggle="tab"
            class="col tab"
            :class="{ active: tabListOpen }"
            @click="activeTab('open')"
          >
            ยังไม่ได้ปิด
          </li>
          <li
            role="presentation"
            data-toggle="tab"
            class="col tab"
            :class="{ active: tabListClose }"
            @click="activeTab('close')"
          >
            ปิดแล้ว
          </li>
        </ul>
        <div class="el-table">
          <el-table
            :data="tableData"
            :default-sort="{ prop: 'topic.isNotReply', order: 'descending' }"
            style="width: 100%; max-height: 100%; overflow: auto;"
            :row-class-name="tableRowNotice"
            @row-click="handleRowClick"
            @sort-change="sortContent"
          >
            <el-table-column
              prop="contactId"
              label="เลขที่การติดต่อ"
              sortable
              :min-width="10"
            >
              <template slot-scope="scope" class="text-center">
                #{{ scope.row.contactId }}
              </template>
            </el-table-column>
            <el-table-column
              prop="contactCategory.title"
              label="ประเภทการติดต่อ"
              sortable
              :min-width="10"
            >
            </el-table-column>
            <el-table-column
              prop="topic.detail"
              label="รายละเอียด"
              :min-width="15"
            >
            </el-table-column>
            <el-table-column
              prop="createdByUser"
              label="ชื่อผู้ติดต่อ"
              sortable
              :min-width="10"
            >
            </el-table-column>
            <el-table-column
              prop="project.projectName"
              label="ชื่อโครงการ"
              sortable
              :min-width="10"
            >
            </el-table-column>
            <el-table-column
              prop="home.addressNo"
              label="บ้านเลขที่"
              sortable
              :min-width="7.5"
            >
            </el-table-column>
            <el-table-column
              prop="createdAt"
              label="เริ่มการติดต่อ"
              sortable
              :min-width="15"
            >
            </el-table-column>
            <el-table-column
              prop="topic.latestReplyAt"
              label="สนทนาคร้งล่าสุด"
              sortable
              default-sort
              :min-width="15"
            >
            </el-table-column>
            <el-table-column
              prop="topic.isNotReply"
              label="Action"
              sortable
              :min-width="7.5"
            >
              <template slot-scope="scope" class="text-center">
                <i class="is-not-reply"></i>
                <a
                  class="el-button sc-button btn-block sc-btn-outline el-button--text el-button--medium"
                  type="text"
                  size="medium"
                  @click="
                    selectProject(
                      `${scope.row.contactId}`,
                      `${scope.row.project.projectId}`,
                      `${scope.row.project.projectName}`
                    )
                  "
                  >See More</a
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="height: 50px; padding: 9px 0; text-align: right;">
          <el-pagination
            style="margin-left: auto; display: inline-block;"
            layout="prev, pager, next"
            background
            @current-change="pageCurrentChange"
            :current-page="currentPage"
            :page-size="perPage"
            :total="totalTopic"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import JsonExcel from "vue-json-excel";
import axios from "axios";
import moment from "moment-timezone";
import InfiniteLoading from "vue-infinite-loading";
import {
  Input,
  Select,
  OptionGroup,
  Option,
  Button,
  Table,
  TableColumn,
  DatePicker,
  Pagination
} from "element-ui";
import { setTimeout } from "timers";

export default {
  components: {
    elInput: Input,
    elSelect: Select,
    elOption: Option,
    elOptionGroup: OptionGroup,
    elButton: Button,
    elDatePicker: DatePicker,
    elTable: Table,
    elTableColumn: TableColumn,
    elPagination: Pagination,
    downloadExcel: JsonExcel
  },
  data() {
    return {
      perPage: 15,
      currentPage: 1,
      topicId: "",
      textReply: "",
      name: "",
      conversationCategory: "",
      conversationCategoryList: [],
      project: "",
      projectList: [],
      homeAddress: "",
      createdAt: "",
      latestReplyAt: "",
      tabListOpen: true,
      tabListClose: false,
      filterStatus: "IN_PROGRESS",
      totalTopic: null,
      tableData: [],
      conversationStatField: {
        "Topic ID": "topicId",
        "Topic Cattegory": "topicCattegory",
        "Topic Title": "topicTitle",
        User: "user",
        Project: "project",
        "Home Address": "homeAddress",
        "Topic Reply ID": "topicReplyId",
        "Topic Reply Message": "topicReplyMessage",
        "User Reply": "userReply",
        "Admin Reply": "adminReply",
        "Started At": "startedAt",
        "Reply At": "replyAt",
        "Closed At": "closedAt"
      },
      conversationStatData: []
    };
  },
  watch: {
    //
  },
  async beforeMount() {
    await this.getProject();
    await this.getconversationCategories();
    await this.getconversationList();
  },
  async mounted() {
    //
  },
  computed: {},
  methods: {
    activeTab(tab) {
      if (tab === "close") {
        this.tabListOpen = false;
        this.tabListClose = true;
        this.filterStatus = "CLOSED";
      } else {
        this.tabListOpen = true;
        this.tabListClose = false;
        this.filterStatus = "IN_PROGRESS";
      }

      this.getconversationList();
    },
    pageCurrentChange(val) {
      const vm = this;
      this.currentPage = val;
      if (vm.tableData || vm.tableData.length !== 0) {
        var dataRows = $(".el-table .el-table__body-wrapper .el-table__row");
        dataRows.hide();
        dataRows.each((index, element) => {
          if (
            index >= (vm.currentPage - 1) * vm.perPage &&
            index < vm.currentPage * vm.perPage
          ) {
            dataRows.eq(index).show();
          }
        });
      }
    },
    async getconversationCategories() {
      const vm = this;
      await axios
        .get(`${process.env.HOST}/api/conversations/categories`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`
          }
        })
        .then(async res => {
          vm.conversationCategoryList = res.data;
        })
        .catch(e => {
          throw e;
        });
    },
    async getProject() {
      const vm = this;
      const projectHighRise = await this.getProjectByType("H");
      this.projectList.push({
        label: "Project High Rise",
        projects: projectHighRise
      });

      const projectLowRise = await this.getProjectByType("L");
      this.projectList.push({
        label: "Project Low Rise",
        projects: projectLowRise
      });
    },
    async getProjectByType(type) {
      const vm = this;
      let projectData = null;
      await axios
        .get(`${process.env.HOST}/api/admin/projects`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`
          },
          params: { type }
        })
        .then(async res => {
          projectData = res.data;
        })
        .catch(e => {
          throw e;
        });

      return projectData;
    },
    async getconversationList() {
      const vm = this;
      await axios
        .get(`${process.env.HOST}/admin/conversations/list`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`
          },
          params: {
            topicId: vm.topicId,
            textReply: vm.textReply,
            name: vm.name,
            conversationCategory: vm.conversationCategory,
            project: vm.project,
            homeAddress: vm.homeAddress,
            createdAt: vm.createdAt
              ? `${moment(vm.createdAt[0]).format(
                  "YYYY-MM-DD 00:00:00"
                )} - ${moment(vm.createdAt[1]).format("YYYY-MM-DD 23:59:59")}`
              : "",
            latestReplyAt: vm.latestReplyAt
              ? `${moment(vm.latestReplyAt[0]).format(
                  "YYYY-MM-DD 00:00:00"
                )} - ${moment(vm.latestReplyAt[1]).format(
                  "YYYY-MM-DD 23:59:59"
                )}`
              : "",
            status: vm.filterStatus
          }
        })
        .then(async res => {
          vm.tableData = res.data;
          let data = res.data;
          if (data.length > 0) {
            vm.totalTopic = data.length;
            await data.map((value, index) => {
              data[index].createdByUser = `${value.createdByUser.firstName} ${
                value.createdByUser.lastName
              }`;
              data[index].createdAt = moment(data[index].createdAt)
                .tz("Asia/Bangkok")
                .format("YYYY-MM-DD HH:mm:ss");
              data[index].topic.latestReplyAt =
                data[index].topic_replies.length > 0
                  ? moment(data[index].topic_replies[0].createdAt)
                      .tz("Asia/Bangkok")
                      .format("YYYY-MM-DD HH:mm:ss")
                  : " - ";

              if (data[index].topic_replies.length > 0) {
                data[index].topic.isNotReply = data[index].topic_replies[0]
                  .userId
                  ? true
                  : false;
              } else {
                data[index].topic.isNotReply = true;
              }
            });
          }

          vm.tableData = data;
        })
        .catch(e => {
          throw e;
        });

      await this.pageCurrentChange(1);
      await this.genCsvReport();
    },
    tableRowNotice({ row, rowIndex }) {
      if (row.topic.isNotReply === true) {
        return "topic-is-not-reply";
      }
      return "";
    },
    async sortContent() {
      await this.pageCurrentChange(1);
    },
    selectProject(contactId, id, name) {
      this.$store.state.projectName = name;
      this.$store.state.projectId = id;

      localStorage.setItem("projectName", name);
      localStorage.setItem("projectId", id);

      this.$router.push({
        name: "ContactDetailNew",
        params: { contactId: contactId }
      });
    },
    handleRowClick(row) {
      this.selectProject(
        row.contactId,
        row.project.projectId,
        row.project.projectName
      );
    },
    async genCsvReport() {
      const vm = this;
      vm.conversationStatData = [];

      let dataCsv = [];
      await vm.tableData.forEach((value, index) => {
        if (value.topic_replies.length > 0) {
          value.topic_replies.forEach((subValue, subIndex) => {
            let addedData = {
              topicId: value.contactId,
              topicCattegory: value.contactCategory.title,
              topicTitle: value.topic.detail,
              user: value.createdByUser,
              project: value.project.projectName,
              homeAddress: value.home.addressNo,
              topicReplyId: subValue.topicReplyId,
              topicReplyMessage: subValue.message,
              userReply:
                subValue.createdByUser != null
                  ? `${subValue.createdByUser.firstName} ${
                      subValue.createdByUser.lastName
                    }`
                  : " - ",
              adminReply:
                subValue.createdByAdmin != null
                  ? `${subValue.createdByAdmin.firstName} ${
                      subValue.createdByAdmin.lastName
                    }`
                  : " - ",
              startedAt: moment(value.createdAt)
                .tz("Asia/Bangkok")
                .format("YYYY-MM-DD HH:mm:ss"),
              replyAt: moment(subValue.createdAt)
                .tz("Asia/Bangkok")
                .format("YYYY-MM-DD HH:mm:ss"),
              closedAt:
                value.closed_at != null
                  ? moment(value.closed_at)
                      .tz("Asia/Bangkok")
                      .format("YYYY-MM-DD HH:mm:ss")
                  : " - "
            };
            dataCsv.push(addedData);
          });
        } else {
          dataCsv.push({
            topicId: value.contactId,
            topicCattegory: value.contactCategory.title,
            topicTitle: value.topic.detail,
            user: value.createdByUser,
            project: value.project.projectName,
            homeAddress: value.home.addressNo,
            topicReplyId: " - ",
            topicReplyMessage: " - ",
            userReply: " - ",
            adminReply: " - ",
            startedAt: moment(value.createdAt)
              .tz("Asia/Bangkok")
              .format("YYYY-MM-DD HH:mm:ss"),
            latestReply: " - ",
            closedAt: " - "
          });
        }
      });

      vm.conversationStatData = dataCsv;
    }
  }
};
</script>

<style scoped>
.m-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.contact-list {
  border-top: 1px solid #e0e0e0;
}
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.el-select {
  display: block;
}
.sc-btn-outline {
  border: 1px solid #e27024;
  background-color: transparent;
  color: #e27024;
  box-shadow: none;
  outline: none;
}
.sc-btn-outline:active {
  opacity: 0.75;
}
.table-block {
  position: relative;
  flex-direction: column;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 4px 16px 0 rgba(215, 215, 215, 0.7);
}
.topic-cases.tabs .tab {
  background-color: #efefef;
  font-size: 16px;
  padding: 15px;
}
.topic-cases.tabs .tab.active {
  background-color: #fff;
  color: #e27024;
}
.el-table {
  position: relative;
  padding-left: 0;
  margin-bottom: 0;
}
.el-table::before {
  display: none;
}
.row-container {
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.col-item {
  flex: 1;
  overflow: auto;
}

.el-table__fixed-right::before,
.el-table__fixed::before {
  display: none;
}
.el-table__header-wrapper {
  position: fixed;
  width: 100%;
  z-index: 1;
}
.el-table__body-wrapper {
  padding-top: 60px;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(226, 112, 36, 0.1);
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #e27024;
  background-color: transparent;
  color: #e27024;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #e27024;
}
.el-table .ascending .sort-caret.ascending {
  border-bottom-color: #e27024;
}
.el-table .descending .sort-caret.descending {
  border-top-color: #e27024;
}
.contact-list .el-table tbody .el-button.sc-button {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/contact/ContactListNew.vue